import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class StoriesSlider {
	constructor(section) {
		this.section = section;
		this.swiperEl = this.section.querySelector('.swiper.quoteSlider');
		this.slides = [...this.swiperEl.querySelectorAll('.swiper-slide')];
		this.title = this.section.querySelector('.mainTitle');
		this.navButtons = this.section.querySelector('.swiper-navigation');
		this.init();
	}

	init() {
		this.swiper = new Swiper(this.swiperEl, {
			modules: [Autoplay, Navigation],
			speed: 700,
			slidesPerView: 'auto',
			watchSlidesProgress: true,
			loop: true,
			navigation: {
				nextEl: '.swiper-navigation .next',
				prevEl: '.swiper-navigation .prev',
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true
			},
		});

		document.fonts.ready.then(() => {
			this.titleSplit = SplitText.create(this.title, {type: "lines", autoSplit: true, mask: "lines", aria: "none"});

			// Reset slider ogni volta che entra in viewport
			ScrollTrigger.create({
				trigger: this.section,
				onEnter: () => this.swiper.slideTo(0),
				onEnterBack: () => this.swiper.slideTo(0),
			});

			this.tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.section,
					start: "top 60%",
					once: true,
				},
				defaults: {ease: "expo.out", force3D: true},
			});

			this.tl
				.set([this.title], {autoAlpha: 1}, 0)
				.from(this.titleSplit.lines, { yPercent: 50, autoAlpha: 0, duration: 1.3, stagger: 0.2, ease: "expo.inOut" }, "<")
				.add(() => {
					this.titleSplit.revert();
					gsap.to([...document.querySelectorAll('.quote-in'), ...document.querySelectorAll('.quote-out')], {opacity: 1, duration: 0.6});
				}, ">")
				.to(this.slides, {opacity: 2, stagger: 0.2, duration: 2, ease: "power2.inOut"}, 0.4)
				.to(this.navButtons, {opacity: 1, duration: 1}, 1.5)
		});

		return this.tl;
	}
}
